import React, { useEffect, useRef, useState } from "react";
import Modal from "react-modal";
import styled from "styled-components";

import {isAddress} from "../../utils/chainUtils";
import {savePublicAddressToBackend} from "../../utils/backendUtils";
import { setWalletDetails } from "../../utils/loginHelper";

import CancelIcon from "../../assets/cancel_icon.svg";
import { Bars } from "react-loader-spinner";

const HeaderSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 130.5%;
  display: flex;
  align-items: center;
  color: #FFFFFF;
`


const InputContainerDiv = styled.div`
  /* width: 398px; */
  width: 100%;
  height: 44px;
  display:flex;
  border: 1px solid rgba(255, 255, 255, 0.08);
  align-items: center;
`

const StyledInput = styled.input`
  /* width: 326px; */
  width: 100%;
  height: 19px;
  background: #131313;
  padding: 11px 16px;
  display: flex;
  align-items: center;
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  border: none;
  color: white;
  :placeholder,
  :-webkit-input-placeholder {
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: rgba(255, 255, 255, .4);
  }
`

const ActionButtonDiv = styled.div`
  /* width: 398px; */
  width: 100%;
  height: 44px;
  background: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-top: 30px;
`

const ActionButtonTextSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;
`

const InfoSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  color: #FFFFFF;
  opacity: 0.45;
`

export default function AddPublicAddressComponent(props) {

    const [inputText, setInputText] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    
    useEffect(() => {
        
    },[]);

    let modalWidth = "446px";
    let modalHeight = "338px";
    
    const handleInputText  = (value)=>{
	setInputText(value)
    }

    const addWalletClicked = (val) => {
        if(!isAddress(val)){
            console.log('damn');
            return;
        }
        savePublicAddressToBackend(val);
        setShowLoader(true);
        props.handleModalCloseEvent();
        setWalletDetails();
    }
    
    return (
        <>
            <Modal
	        isOpen={props.isOpen}
	        style={{
		    content: {
		        background: "#0F0F0F",
		        maxWidth: modalWidth,
		        maxHeight: modalHeight,
		        marginLeft: "auto",
		        marginRight: "auto",
		        marginTop: "auto",
		        marginBottom: "auto",
		        border:"none",
		    }
	        }}
	    >
                <div style={{marginLeft:24, marginTop:30,
			     marginRight:24, marginBottom:30,
			     position: "relative"
		}}>
                    <img onClick={()=>{props.handleModalCloseEvent()}}
		         src={CancelIcon}
		         style={{
			     position: "absolute", opacity: 0.4,
			     height: 14, width:14,
			     right:10, cursor:"pointer",
			     zIndex:10
		         }}
		    />
                    <HeaderSpan>
                        Add Your Wallet
                    </HeaderSpan>
                    <InfoSpan style={{marginTop:10}}>
                        Copy and Paste the Public address
                        from your (Metamask, Coinbase etc) Wallet 
                    </InfoSpan>
                    <InputContainerDiv style={{marginTop: 24}}>
			<StyledInput
			    placeholder={"Enter public address"}
			    value={inputText}
			    onChange={e =>handleInputText(e.target.value)}
			/>
		    </InputContainerDiv>
                    <ActionButtonDiv onClick={()=>{
                        addWalletClicked(inputText)}}>
                        {(!showLoader)  && (
                            <ActionButtonTextSpan>
                                ADD WALLET
                            </ActionButtonTextSpan>
                        )}
                        {(showLoader)  && (
                            <Bars
                                heigth="30" width="30"
                                color="grey"
                                ariaLabel="loading-indicator" />
                        )}
                    </ActionButtonDiv>
                </div>
            </Modal>

        </>
    );
}
